export default "__VITE_ASSET__V8Xp6g31__"